<div
    *ngIf="customerLanding$ | async; let customerLanding; else: loading"
    class="login-top-part-wrapper"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-image': 'url(' + customerLanding.background_url + ')' }"
>
    <div class="layer"></div>

    <app-full-layout [haveLoginFooter]="true">
        <div class="flex-container" fxLayout="row wrap" fxLayoutAlign="center center">
            <mat-card
                fxLayout="column"
                fxLayoutAlign="center center"
                class="account-activation"
                fxFlex="400px"
                fxFlex.sm="50%"
                fxFlex.xs="90%"
            >
                <mat-card-content class="mb-0" fxLayout="column" fxLayoutAlign="center center">
                    <mat-card-title>
                        <h3 class="title" i18n>Activate account</h3>
                    </mat-card-title>
                    <div *ngIf="$error | async; let error">
                        <app-form-error
                            *ngIf="409 === error.error.status_code"
                            header="Account already activated!"
                            i18n-header
                            [messages]="error.error.messages"
                        >
                            <span i18n>Please use </span><a [routerLink]="['/guest/login']" i18n>Login</a>
                            <span i18n> to login to your account, or use </span>
                            <a [routerLink]="['/guest/password/forget']" i18n>Forgot your password</a>
                            <span i18n> to reset your account password.</span>
                        </app-form-error>

                        <app-form-error
                            *ngIf="403 === error.error.status_code"
                            header="Invalid token!"
                            i18n-header
                            [messages]="error.error.messages"
                        ></app-form-error>
                    </div>
                    <form [formGroup]="activationGroup">
                        <div *ngIf="!academies" fxLayout="row wrap" fxLayoutAlign="center">
                            <mat-form-field fxFlex="0 0 100%">
                                <mat-placeholder>
                                    <i class="material-icons app-input-icon">account_box</i>
                                    <ng-container i18n>User name</ng-container>
                                </mat-placeholder>
                                <input matInput type="text" formControlName="username" required />
                            </mat-form-field>

                            <mat-form-field fxFlex="0 0 100%">
                                <mat-placeholder>
                                    <i class="material-icons app-input-icon">lock</i>
                                    <ng-container i18n="@@passwordActivation">Password</ng-container>
                                </mat-placeholder>
                                <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility>
                                <input
                                    #password
                                    matInput
                                    [type]="toggle.type"
                                    [formControl]="passwordComponent.passwordFormControl"
                                    required
                                />
                                <mat-hint align="end" aria-live="polite">
                                    {{ password.value.length }} / {{ passwordComponent.max }}
                                </mat-hint>
                            </mat-form-field>
                            <!--@angular-material-extensions/password-strength's main component-->
                            <mat-password-strength #passwordComponent [password]="password.value">
                            </mat-password-strength>
                            <!--Password's strength info-->
                            <mat-password-strength-info
                                lowerCaseCriteriaMsg="contains at least one lower character"
                                i18n-lowerCaseCriteriaMsg
                                upperCaseCriteriaMsg="contains at least one upper character"
                                i18n-upperCaseCriteriaMsg
                                digitsCriteriaMsg="contains at least one digit character"
                                i18n-digitsCriteriaMsg
                                specialCharsCriteriaMsg="contains at least one special character"
                                i18n-specialCharsCriteriaMsg
                                minCharsCriteriaMsg="contains at least 8 characters"
                                i18n-minCharsCriteriaMsg
                                [passwordComponent]="passwordComponent"
                            >
                            </mat-password-strength-info>

                            <mat-form-field fxFlex="0 0 100%">
                                <mat-placeholder>
                                    <i class="material-icons app-input-icon">lock</i>
                                    <ng-container i18n="@@passwordConfirmationOfActivation"
                                        >Password confirmation</ng-container
                                    >
                                </mat-placeholder>
                                <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility>
                                <input matInput [type]="toggle.type" formControlName="password_confirmation" required />
                                <p
                                    class="error"
                                    *ngIf="
                                        activationGroup.hasError('passwordsDoNotMatch') &&
                                        activationGroup.get('password_confirmation').dirty
                                    "
                                    i18n="@@passwordDoesNotMatch"
                                >
                                    password does not match
                                </p>
                            </mat-form-field>
                        </div>
                        <app-academy-select
                            *ngIf="academies"
                            [academies]="academies"
                            [control]="activationGroup.get('short_name') | cast"
                        ></app-academy-select>
                    </form>
                </mat-card-content>
                <mat-card-actions fxLayout="column" fxLayoutAlign="center center" class="flex">
                    <!-- <div class="flex-space"></div>
                    <button mat-button routerLink="../../login" i18n="@@cancelActivateAccount">
                        Cancel
                    </button>
                    <span class="space"></span>
                    <button
                        mat-raised-button
                        color="primary"
                        type="submit"
                        (click)="onSubmit()"
                        [disabled]="activationGroup.invalid"
                        i18n="@@activateAccountSubmit"
                    >
                        Activate account
                    </button>
                    <div class="flex-space"></div> -->
                    <div fxLayoutAlign="center center" fxLayout="column" fxFlex="1 1 90%" class="signup-button">
                        <div class="reg-wrapper mb-1" fxFlex="1 1 90%" fxFlex.lt-md="1 1 100%">
                            <button
                                (click)="onSubmit()"
                                mat-raised-button
                                color="primary"
                                type="submit"
                                [disabled]="activationGroup.invalid"
                                i18n="@@activateAccountSubmit"
                            >
                                Activate account
                            </button>
                        </div>
                        <div fxFlex="1 1 48%" fxFlex.lt-md="1 1 100%">
                            <button mat-button [routerLink]="['/guest/start']" i18n="@@cancelActivateAccount">
                                Cancel
                            </button>
                        </div>
                    </div>
                </mat-card-actions>
            </mat-card>
        </div>
    </app-full-layout>
</div>

<ng-template #loading>
    <app-kd-logo-loading></app-kd-logo-loading>
</ng-template>
